<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-12 col-lg-12">
        <b-alert :show="showSuccess" variant="success">{{$t('enquestes.success')}}</b-alert>
        <b-alert :show="showError" variant="danger">
          <div v-show='errorCode=="0001"' >{{$t('enquestes.error.0001')}}</div>
          <div v-show='errorCode=="0006"' >{{$t('enquestes.error.0006')}}</div>
          <div v-show='errorCode=="0007"' >{{$t('enquestes.error.0007')}}</div>
          <div v-show='errorCode=="0003"' >{{$t('enquestes.error.0003')}}</div>
          <div v-show='errorCode=="0008"' >{{$t('enquestes.error.0008')}}</div>
        </b-alert>
      </div>  
    </div>
    <div class="row" v-show="showPreambul">
      <div class="col-xl-12 col-lg-12">
        <div class="mb-4 preambul-enquesta">
          <div class="mb-2" style="text-align: center;"><h5>{{$t('enquestes.preambul.1')}}</h5></div>
          <div class="m-1" style="text-align: justify;">{{$t('enquestes.preambul.2')}}</div>
          <div class="m-1" style="text-align: justify;">{{$t('enquestes.preambul.3')}}</div>
          <div class="m-1"><h6><a @click="onShowMesInfo()">{{$t('enquestes.preambul.info.enllac')}}</a></h6></div>
          <div class="m-1" style="background-color: #e9ecef" v-show="showMesInfo">
                <div class="m-1" style="text-align: justify;"><b>{{$t('enquestes.preambul.info.titol')}}</b></div>
                <div class="m-1" style="text-align: justify;">{{$t('enquestes.preambul.info.1')}}</div>
                <div class="m-1" style="text-align: justify;">{{$t('enquestes.preambul.info.2')}}</div>
                <div class="m-1" style="text-align: justify;">{{$t('enquestes.preambul.info.3')}}</div>
                <div class="m-1" style="text-align: justify;">{{$t('enquestes.preambul.info.5')}}</div>
                <div class="m-1"><a href="https://www.vic.cat/politica-de-privacitat" target="_blank" >aquí</a></div>
          </div>
          <div class="m-1" style="text-align: justify;">{{$t('enquestes.preambul.4')}}</div>
          <div class="m-1" style="text-align: justify;">{{$t('enquestes.preambul.5')}}</div>
        </div>
        <div class="botonera-enquesta">          
          <b-button class="btn-enquesta" variant="primary" @click.prevent="onStart">
            {{$t('btn.comencar')}}
          </b-button>
        </div>
      </div>
    </div>            
    <div class="row" v-show="showPreambul==false && showSuccess == false">
      <div class="col-xl-12 col-lg-12">    
        <h1 class="h4 mb-2 text-gray-800">{{enquesta.questionari.titol | etiqueta}}</h1>        
      </div>
    </div>                    
    <div class="row" v-show="showPreambul==false && showSuccess == false">
      <div class="col-xl-12 col-lg-12">        
        <template v-for="(item) in enquesta.questionari.preguntes">          
          <PreguntaOpcio ref="pregunta" v-bind:pregunta="item" v-bind:idPregunta="item.idPregunta"
          v-bind:numPregunta="`${item.ordre+1}`" v-bind:valorInicial="getResposta(item.idPregunta)" 
          v-bind:key="item.idPregunta" v-if='item.tipus==="opcio"' v-show="item.idPregunta==idxPreguntaActual" />
          
          <PreguntaText ref="pregunta" v-bind:pregunta="item" v-bind:idPregunta="item.idPregunta" 
          v-bind:numPregunta="`${item.ordre+1}`" v-bind:valorInicial="getResposta(item.idPregunta)" 
          v-bind:key="item.idPregunta" v-if='item.tipus==="text"' v-show="item.idPregunta==idxPreguntaActual" />

          <PreguntaRang ref="pregunta" v-bind:pregunta="item" v-bind:idPregunta="item.idPregunta" 
          v-bind:numPregunta="`${item.ordre+1}`" v-bind:valorInicial="getResposta(item.idPregunta)" 
          v-bind:key="item.idPregunta" v-if='item.tipus==="rang"' v-show="item.idPregunta==idxPreguntaActual" />                  
        </template>        
        <div class="progress-enquesta" v-show="this.getOrdreActual()>=0">
        <b-progress :value="this.getOrdreActual()" :max="this.getMaxOrdre()" class="mb-2"></b-progress>
        <h6 class="mb-3 font-weight-bold">{{this.progressLabel}}</h6>        
        </div>
        <div class="botonera-enquesta" v-show="numRespostesActual>=0">
          
          <b-button id="back" class="btn-enquesta" variant="outline-info" @click.prevent="onBack" v-show="this.getOrdreActual()>0">
            <b-icon icon="chevron-left" aria-hidden="true"></b-icon> {{$t('enquestes.anterior')}}
          </b-button>
          <b-button id="next" class="btn-enquesta" variant="primary" @click.prevent="onNext" v-show="!esPreguntaUltima">
            {{$t('enquestes.seguent')}}<b-icon icon="chevron-right" aria-hidden="true"></b-icon>
          </b-button> 
          <b-button id="submit" class="btn-enquesta" variant="primary" @click.prevent="onNext" v-show="esPreguntaUltima">
            <b-icon icon="archive" aria-hidden="true"></b-icon> {{$t('enquestes.enviar')}}
          </b-button>     
          
        </div>
      </div>

    </div>
    
  </div>
</template>

<script>
import loginService from "../../services/LoginService";
import submitService from "../../services/SubmitService";
import PreguntaOpcio from "./PreguntaOpcio";
import PreguntaText from "./PreguntaText";
import PreguntaRang from "./PreguntaRang";
export default {
  name: "enquesta",
  components: {
    PreguntaOpcio,
    PreguntaText,
    PreguntaRang
  },    
  data() {
    return {
      showSuccess: false,
      showError: false,
      errorCode : '',
      showPreambul: false,
      showQuestionari: false,
      showMesInfo: false,
      idxPreguntaActual: -1,
      numRespostesActual: -1,
      esPreguntaUltima: false,
      enquesta : {
        questionari:{
          titol:{
            text: ''
          },
          descripcio:{
            text:''
          },
          preguntes: []
        }
      },
      respostaActual : null,
      respostes : []
    };
  },
  computed: {
    progressLabel: function () {
      return  (this.getOrdreActual()+1);
    }
  },  
  methods: {
    onShowMesInfo() {
      this.showMesInfo = !this.showMesInfo;
    },
    getResposta(idPregunta) {
      let i;
      for(i = 0; i < this.enquesta.respostes.length; i++) {
          if(this.enquesta.respostes[i].idPregunta == idPregunta){
              return this.enquesta.respostes[i].valor;
          }
      }      
      return '';
    },
    setEnquesta(e) {
      this.enquesta = e;
      this.esPreguntaUltima = this.enquesta.esPreguntaUltima;
      this.numRespostesActual = this.enquesta.respostes.length;
      this.idxPreguntaActual = this.enquesta.idxPreguntaActual;

      if(this.enquesta.respostes.length == 0){
        this.idxPreguntaActual = this.enquesta.questionari.preguntes[0].idPregunta;
        this.showPreambul = true;       
      }
      
      if(this.enquesta.estat == 1){
        this.showSuccess = true;
      }
    },
    getEnquesta() {            
      submitService.getSubmit(this.access_key)
        .then(response => {
          this.setEnquesta(response.data);                              
        })
        .catch(e => {
          console.log(e);
        });
    },onNext(){      
      console.log();
      if(this.recuperarPreguntaActual().validate()){
        
        if(this.esPreguntaUltima){
          if(!confirm(this.$t('enquestes.confirm'))){
            return;
          }
        }        
        submitService.saveResposta(this.access_key,this.idxPreguntaActual,this.recuperarPreguntaActual().getValor()).then(response => {
          this.setEnquesta(response.data);    
        })
        .catch(e => {
          console.log(e);
        });
        
      }      
    },onBack(){
      submitService.respostaAnterior(this.access_key).then(response => {
        this.setEnquesta(response.data);
      });
    },onStart(){
       this.showPreambul = false;
    },recuperarPreguntaActual(){
      return this.$refs.pregunta.filter(p => p.getIdPregunta() == this.idxPreguntaActual)[0];
    },getOrdreActual(){
      if(this.enquesta.questionari.preguntes.length>0){
        return this.enquesta.questionari.preguntes.filter(p => p.idPregunta == this.idxPreguntaActual)[0].ordre;
      } else {
        return -1;
      }
    },getMaxOrdre(){
      if(this.enquesta.questionari.preguntes.length>0){
        return this.enquesta.questionari.preguntes[this.enquesta.questionari.preguntes.length-1].ordre;
      } else {
        return -1;
      }
    }
  },
  mounted() {    
        this.access_key = this.$route.params.access_key;     
        loginService.logout();
        loginService.loginAccessKey(this.access_key).then(response => {                      
          this.getEnquesta();
          console.log(response.data);                
        })
        .catch(e => {
          if(e.response){
            this.errorCode = e.response.data.codi;
          }else{
            this.errorCode = "0001";
          }          

          this.showError = true;
        });
  }
};
</script>

<style>
.botonera-enquesta {
  text-align: center;
}
.btn-enquesta {
  margin-left: 5px;
  margin-right: 5px;
}
.preambul-enquesta{
  text-align: justify;
}
</style>
